import { Component, OnInit } from "@angular/core";
import { request } from "express";
import { map } from "rxjs/operators";
import { DownloadService } from "src/app/services/download.service";
import { NoteService } from "src/app/services/note.service";
import { UserService } from "src/app/services/user.service";
export interface QueryParams {
  user_id?: number;
  page?: number;
  search?: string;
}
@Component({
  selector: "app-notes-download",
  templateUrl: "./notes-download.component.html",
  styleUrls: ["./notes-download.component.scss"],
})
export class NotesDownloadComponent implements OnInit {
  public notes: Array<any> = [];
  public isLoading: boolean = false;
  public data: any;
  public page = 1;
  public userId = null;
  public arangersList = [];

  public qp: QueryParams = {
    page: this.page,
    user_id: this.userId,
    search: "",
  };

  constructor(
    private noteService: NoteService,
    private donwloadService: DownloadService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.paginate();
    this.getAllArrangers();
  }

  private getAllArrangers() {
    this.userService.getAllArrangers().subscribe((arrResp) => {
      this.arangersList = arrResp.data.arrangers;
      this.arangersList = this.arangersList.map((data) => {
        return {
          label: data.user_details.name + " " + data.user_details.surname,
          value: data.id,
        };
      });
      this.arangersList.unshift({
        label: "Wszyscy",
        value: null,
      });
    });
  }

  public onSearch() {
    this.qp.page = 1;
    this.paginate();
  }

  public download(note) {
    this.donwloadService.downloadNoteByAdmin(note).subscribe((req) => {
      saveAs(req, note.source.file_name);
    });
  }

  public downloadSound(note) {
    this.donwloadService.downloadSoundByAdmin(note).subscribe((req) => {
      saveAs(req, note.title + "_" + note.sample_audio);
    });
  }

  public onPaginate(ev) {
    this.qp.page = ev.page + 1;
    this.paginate();
  }

  private paginate() {
    this.noteService.getNotesByAdmin(this.qp).subscribe((request) => {
      this.isLoading = false;
      this.data = request.data;
      this.notes = request.data.data;
    });
  }
}
